/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { buildHashWithAuthMode, getLocationHash } from 'js/lib/authModeDeepLinkUtils';
import { useLocation, useNavigate } from 'js/lib/useRouter';

import { Button } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { useMobileWebConversationalDiscoveryExperiment } from 'bundles/unified-common/contexts/MobileWebConversationalDiscoveryExperimentContext';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  joinForFreeButton: css`
    margin-left: var(--cds-spacing-50);

    /* Hide the button on the small screens where space is limited */
    @media (max-width: 435px) {
      display: none;
    }
  `,
  // The mobile-web conversational-discovery treatment's icon row already applies its own uniform
  // 6px `gap` (MERCH-3449); this margin would double-count on top of that.
  noMarginLeft: css`
    margin-left: 0;
  `,
};

const MobileJoinForFreeButton = () => {
  const track = useTracker();
  const location = useLocation();
  const navigate = useNavigate();
  const { mobileWebConversationalDiscoveryEnabled } = useMobileWebConversationalDiscoveryExperiment();

  const handleClick = () => {
    track('click_button', {
      button: { name: 'signup' },
      pageSection: { sectionName: 'sticky_page_navigation' },
    });

    const rawSearch =
      (location?.search && location.search.startsWith('?') ? location.search.slice(1) : location?.search) || '';
    const searchParams = new URLSearchParams(rawSearch);
    searchParams.delete('authMode');
    const searchString = searchParams.toString();

    navigate(
      {
        pathname: location?.pathname || '/',
        search: searchString ? `?${searchString}` : '',
        hash: buildHashWithAuthMode(getLocationHash(location), 'signup'),
      },
      { replace: true }
    );
  };

  return (
    <Button
      size="small"
      variant="secondary"
      onClick={handleClick}
      css={[styles.joinForFreeButton, mobileWebConversationalDiscoveryEnabled && styles.noMarginLeft]}
    >
      {_t('Join for Free')}
    </Button>
  );
};

export default MobileJoinForFreeButton;
